<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        用户名 (ID: {{search.userid}}) 金额详情
      </h3>
    </div>
    <layout-panel :show-header="false">
      <el-row>
        <el-col :span="22">
          <span>可提现金额: {{detail.balance}} 冻结金额: {{detail.frozenbalance}} 已提现金额: {{detail.totalwithdraw}}</span>
        </el-col>
        <el-col :span="2"
                style="text-align:right">
          <router-link style="text-decoration:none;color:rgb(88,157,248);"
                       :to="{path: '/users/point?userid='+id}">
            <span>零豆明细</span>
          </router-link>
        </el-col>
      </el-row>
    </layout-panel>

    <layout-panel :collapse="true">
      <span slot="header">搜索</span>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               class="layout-search-form medium"
               @submit.native.prevent="onSearch()">
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="状态"
                          prop="credit_type">
              <el-select v-model="search.credit_type"
                         placeholder="请选择状态"
                         clearable>
                <el-option v-for="(option,index) in options.credit_type"
                           :label="option.keyword"
                           :value="option.id"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="提现方式"
                          prop="withdrawtype">
              <el-select v-model="search.withdrawtype"
                         placeholder="请选择提现方式"
                         clearable>
                <el-option v-for="(option,index) in options.withdraw_type"
                           :label="option.keyword"
                           :value="option.id"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"></el-table-column>
        <el-table-column prop="desc"
                         label="描述"></el-table-column>
        <el-table-column prop="credit"
                         label="金额"></el-table-column>
        <el-table-column prop="credit_type"
                         label="状态">
          <template slot-scope="scope">
            <span v-for="value in options.credit_type"
                  v-if="value.id === scope.row.credit_type">
              {{value.keyword}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="withdrawtype"
                         label="提现方式">
          <template slot-scope="scope">
            <span v-for="value in options.withdraw_type"
                  v-if="value.id * 1 === scope.row.withdrawtype * 1">
              {{value.keyword}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at"
                         label="操作来源"></el-table-column>
        <el-table-column prop="created_at"
                         label="创建时间"></el-table-column>
        <el-table-column prop="updated_at"
                         label="更新时间"></el-table-column>
        <el-table-column prop="fail_reason"
                         label="退回原因"></el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

  </div>
</template>

<script>
import table from '@core/mixins/table-v3'

export default {
  mixins: [table],
  data () {
    return {
      id: this.$route.query.userid || 0,
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
      search: {
        credit_type: null,
        withdrawtype: null,
        userid: this.$route.query.userid || 0,
      },
      // 搜索字段申明
      searchFieldType: {
        credit_type: Number,
        userid: Number,
        withdrawtype: Number,
      },
      detail: {
        balance: 0,
        frozenbalance: 0,
        totalwithdraw: 0,
      },
    }
  },
  computed: Vuex.mapState({
    options: state => state.users.userOptions,
  }),
  created () {
    if (this.options.length <= 0) {
      this.$store.dispatch('getUserRelatedOptions')
    }
    this.getUserCredit()
  },
  methods: {
    ...Vuex.mapActions([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getCreditList', params)
    },
    getUserCredit () {
      request.common('getUserCredit', this.id).then(({data}) => {
        filter.setLoop(this.detail, data)
      })
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/views/users/pages/UsersAmountTable.vue